// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__24Ss7","containerItemsCenter":"Skeleton_containerItemsCenter__16sqG"};